import { Typography } from '@mui/material';
import Box from '@mui/material/Box/Box';
import React, { ReactElement } from 'react';
const InvestorItem = ({
  icon,
  title,
  subTitle,
  preValue,
  color,
  bgColor,
  iconBgColor,
  bgImage
}: {
  icon: ReactElement;
  title: string;
  subTitle: string | number;
  preValue: string;
  bgColor: string;
  color: string;
  iconBgColor: string;
  bgImage?: string;
}) => {
  return <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'end',
    bgcolor: bgColor,
    borderRadius: 'var(--corner_radius_m)',
    backgroundImage: {
      xs: 'unset',
      md: bgImage ? `url(${bgImage})` : 'unset'
    },
    width: '100%',
    backgroundSize: 'auto 100%',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    minHeight: {
      xs: 0,
      md: bgImage ? 330 : 0,
      lg: bgImage ? 360 : 0
    },
    height: '100%',
    m: 'auto'
  }} data-sentry-element="Box" data-sentry-component="InvestorItem" data-sentry-source-file="InvestorItem.tsx">
      <Box sx={{
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      bgcolor: bgColor,
      borderRadius: 'var(--corner_radius_m)',
      gap: 'var(--spacing_xs)',
      px: 'var(--spacing_m)',
      py: 'var(--spacing_xs_nudge)'
    }} data-sentry-element="Box" data-sentry-source-file="InvestorItem.tsx">
        <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: 'var(--spacing_xs)',
        width: '100%'
      }} data-sentry-element="Box" data-sentry-source-file="InvestorItem.tsx">
          <Typography sx={{
          typography: 'bodyMedium__Wallfund'
        }} color='text.text' data-sentry-element="Typography" data-sentry-source-file="InvestorItem.tsx">
            {title}
          </Typography>
          <Box sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 'var(--spacing_xxs)'
        }} data-sentry-element="Box" data-sentry-source-file="InvestorItem.tsx">
            <Typography variant='titleStrong__Wallfund' color={color} data-sentry-element="Typography" data-sentry-source-file="InvestorItem.tsx">
              {subTitle}
            </Typography>
            <Typography variant='bodyRegular__Wallfund' color={'text.text2'} data-sentry-element="Typography" data-sentry-source-file="InvestorItem.tsx">
              {preValue}
            </Typography>
          </Box>
        </Box>
        <Box sx={{
        display: 'flex',
        alignItems: 'center',
        p: 'var(--spacing_xs)',
        bgcolor: iconBgColor,
        height: 'fit-content',
        borderRadius: 'var(--corner_radius_m)'
      }} data-sentry-element="Box" data-sentry-source-file="InvestorItem.tsx">
          {icon}
        </Box>
      </Box>
    </Box>;
};
export default InvestorItem;